module.exports = __webpack_public_path__ + "AntDesign.3a2ba315.ttf";